__turbopack_context__.v({
  "className": "nexafont_29963294-module__p-R4uq__className",
});
